import React, { useContext } from 'react';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { makeStyles, Theme } from '@material-ui/core';
import { NoCoverImage } from '@assets';
import { getFileUrl } from '@utils/urls';

interface CompanyCoverStyleProps {
  isRequest: boolean;
}

const CompanyCover = () => {
  const isRequest = window.location.pathname.includes('/dashboard');
  const { companyCoverImage } = useStyles({ isRequest });
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const partnerInfo = context.partnerInfo;
  const cover = partnerInfo?.cover;
  const fileId = cover?.fileId ?? '';

  return (
    <div className={companyCoverImage}>
      {cover ? (
        <div className="company-cover">
          <img src={getFileUrl(fileId)} alt="cover-img" />
        </div>
      ) : (
        <div className="company-no-cover" />
      )}
    </div>
  );
};

export default CompanyCover;

const useStyles = makeStyles<Theme, CompanyCoverStyleProps>((theme) => ({
  companyCoverImage: {
    maxWidth: 1024,
    height: 232,
    borderRadius: 16,
    marginTop: 15,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      marginLeft: 20,
      marginRight: 20
    },
    [theme.breakpoints.down('xs')]: {
      borderRadius: ({ isRequest }) => (isRequest ? '16px 16px 0px 0px' : 0),
      margin: 0,
      maxWidth: '100%'
    },
    '& .company-cover': {
      maxWidth: '100%',
      height: '100%',
      borderRadius: 16,
      [theme.breakpoints.down('xs')]: {
        borderRadius: ({ isRequest }) => (isRequest ? '16px 16px 0px 0px' : 0)
      },
      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: 16,
        objectFit: 'cover',
        [theme.breakpoints.down('xs')]: {
          borderRadius: ({ isRequest }) => (isRequest ? '16px 16px 0px 0px' : 0)
        }
      }
    },
    '& .company-no-cover': {
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundImage: `url(${NoCoverImage})`,
      backgroundRepeat: 'no-repeat',
      borderRadius: 16,
      [theme.breakpoints.down('xs')]: {
        borderRadius: ({ isRequest }) => (isRequest ? '16px 16px 0px 0px' : 0)
      }
    },

    '& .upload-button': {
      position: 'absolute',
      top: 0,
      right: 0
    }
  }
}));
